import { Dispatch, RefObject, SetStateAction, useEffect, useRef } from "react";

export default function useModalHandler(btnRef: RefObject<HTMLElement>, setModalOpened: Dispatch<SetStateAction<boolean>>) {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!modalRef || !modalRef.current) return;

      const container = modalRef.current as any;

      // the btn click toggle will take care of this
      // skip this from this event
      const isBtn = btnRef && btnRef.current && (btnRef.current as any).contains(e.target);
      const isInside = container.contains(e.target);

      if (!isInside && !isBtn) {
        console.log("setModalOpened(false)");
        setModalOpened(false);
      }
    };

    window.addEventListener("mouseup", handleClick);

    return () => window.removeEventListener("mouseup", handleClick);
  }, [modalRef, setModalOpened, btnRef]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
    // eslint-disable-next-line
  }, []);

  function escFunction(event: KeyboardEvent) {
    if (event.key === "Escape") {
      setModalOpened(false);
    }
  }

  return modalRef;
}
